import React, { Fragment } from 'react';
import { useNavigate } from "react-router-dom";
import ListingPageComponent from '../../components/ListingPageComponent';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import UI_ACTIONS from '../../data/UiActionConstants';
import { getApi } from '../../api/endpoints';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import UiAction from '../../components/UiAction';

const GeneralReportsPage = () => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: false };
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'Report Name',
      attr: 'name',
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_general_reports.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onExportClick(row.id) }>
              <FontAwesomeIcon icon={faFileExcel}/>
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onExportClick = (id) => {
    navigate(`/gereral_reports/${id}/export`)
  }

  return <ListingPageComponent
    key={PAGES.GeneralReportsListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.GeneralReportsListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Reports'}]}
    listingMutation={getApi('generalReports')}
    className="general-reports-listing-page"
    contentHeading="General Reports - Results"
    headers={headers}
    recordsKey="general_reports"
  />
};

export default GeneralReportsPage;


